import { ListaDeInconsistenciaComponent } from './_paginas/listagem-de-inconsistencias/lista-de-inconsistencia.component';
import { InconsistenciaGestorComponent } from './_paginas/tela-de-inconsistencias-gestor/inconsistencia-gestor.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MovimentacaoService } from './_core/services/movimentacao.service';
import { LocalizacaoService } from './_core/services/localizacao.service';
import { AuthenticationService } from './_core/services/authentication/authentication.service';
import { BasicAuthInterceptor } from './_core/helper/basic-auth.interceptor';
import { ErrorInterceptor } from './_core/helper/error.interceptor';
import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { PageService } from './_core/services/page.service';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbCollapseModule, NgbModalModule, NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadService } from './_core/services/upload.service';
import { CadastroBemService } from './_core/services/cadastro-bem.service';
import { TipoDeBemService } from './_core/services/tipo-de-bem.service';
import { LoginService } from './_core/services/login.service';
import { SideMenuService } from './_core/services/sidemenu.service';
import { FileUploadModule } from 'ng2-file-upload';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
//Components
import { HomeComponent } from './_paginas/home/home.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './_paginas/login';
import {
  TipoDeBemComponent,
  TipoDeBensComponent,
  TipoDeBensModalComponent
} from './_paginas/tipo-de-bem';
import {
  CadastrarBensComponent,
  CadastroBensComponent,
  CadastroBensModalComponent
} from './_paginas/cadastro-bem';
import {
  BemFuncionarioComponent,
  BensFuncionariosComponent
} from './_paginas/bem-funcionario';
import {
  SolicitarBensComponent,
  SolicitacaoBensModalComponent,
  SolicitacaoBensComponent
} from './_paginas/solicitar-bens';
import {
  LocalizarBensComponent,
  LocalizacaoBensComponent,
  LocalizacaoBensModalComponent
} from './_paginas/localizacao-bens';
import {
  TelaAprovarGestorComponent,
  TelaDeAprovGestorComponent,
  TelaDeAprovGestorModalComponent
} from './_paginas/tela-de-aprov-gestor';
import {
  TelaDeRecebimentoComponent,
  TelaDeReceberComponent
} from './_paginas/tela-de-recebimento';
import {
  HistoricoComponent,
  HistoricoBensComponent
} from './_paginas/historico-bens';
import {
  RelatorioComponent,
  RelatorioBensComponent
} from './_paginas/relatorio-bens';
import {
  MeuBemComponent,
  MeusBensComponent
} from './_paginas/meus-bens';
import { TelaDeInconsistenciasUsuarioComponent } from './_paginas/tela-de-inconsistencias-usuario/tela-de-inconsistencias-usuario/tela-de-inconsistencias-usuario.component';
import { InconsistenciaUsuarioComponent } from './_paginas/tela-de-inconsistencias-usuario/inconsistencia-usuario.component';
import { TelaDeInconsistenciasGestorComponent } from './_paginas/tela-de-inconsistencias-gestor/tela-de-inconsistencias-gestor/tela-de-inconsistencias-gestor.component';
import { ListagemDeInconsistenciaComponent } from './_paginas/listagem-de-inconsistencias/listagem-de-inconsistencia/listagem-de-inconsistencia.component';
import { MeusBensModalComponent } from './_paginas/meus-bens/meus-bens-modal/meus-bens-modal.component';
import { TelaInconsistenciasGestorModalComponent } from './_paginas/tela-de-inconsistencias-gestor/tela-inconsistencias-gestor-modal/tela-inconsistencias-gestor-modal.component';
import { TelaDeInconsistenciaUserModalComponent } from './_paginas/tela-de-inconsistencias-usuario/tela-de-inconsistencia-user-modal/tela-de-inconsistencia-user-modal.component';
import { ListagemDeInconsistenciaModalComponent } from './_paginas/listagem-de-inconsistencias/listagem-de-inconsistencia-modal/listagem-de-inconsistencia-modal.component';
import { TelaDeRecebimentoModalComponent } from './_paginas/tela-de-recebimento/tela-de-recebimento-modal/tela-de-recebimento-modal.component';
import { HistoricoBensModalComponent } from './_paginas/historico-bens/historico-bens-modal/historico-bens-modal.component';
import { CautelaGruposComponent } from './_paginas/cautela-grupos/cautela-grupos/cautela-grupos.component';
import { GrupoCautelaComponent } from './_paginas/cautela-grupos/grupo-cautela.component';
import { GrupoRecebimentoComponent } from './_paginas/grupo-recebimentos/grupo-recebimento/grupo-recebimento.component';
import { RecebimentoGrupoComponent } from './_paginas/grupo-recebimentos/recebimento-grupo.component';
import { GrupoAlterarCautelaComponent } from './_paginas/grupo-alterar-cautela/grupo-alterar-cautela/grupo-alterar-cautela.component';
import { AlterarCautelaGrupoComponent } from './_paginas/grupo-alterar-cautela/alterar-cautela-grupo.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PermissaoService } from './_core/services/permissao.service';
import { TelaDeLiberacaoModule } from './_paginas/tela-de-liberacao/tela-de-liberacao.module';
import { TelaDeLiberacaoRoutingModule } from './_paginas/tela-de-liberacao/tela-de-liberacao-routing.module';


export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  inputMode: CurrencyMaskInputMode.FINANCIAL
};

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    TipoDeBensComponent,
    TipoDeBemComponent,
    CadastrarBensComponent,
    CadastroBensComponent,
    CadastroBensModalComponent,
    BemFuncionarioComponent,
    BensFuncionariosComponent,
    SolicitarBensComponent,
    SolicitacaoBensComponent,
    TipoDeBensModalComponent,
    LocalizarBensComponent,
    LocalizacaoBensComponent,
    LocalizacaoBensModalComponent,
    SolicitacaoBensModalComponent,
    TelaAprovarGestorComponent,
    TelaDeAprovGestorComponent,
    TelaDeAprovGestorModalComponent,
    TelaDeReceberComponent,
    TelaDeRecebimentoComponent,
    HistoricoComponent,
    HistoricoBensComponent,
    RelatorioComponent,
    RelatorioBensComponent,
    MeuBemComponent,
    MeusBensComponent,
    InconsistenciaUsuarioComponent,
    TelaDeInconsistenciasUsuarioComponent,
    InconsistenciaGestorComponent,
    TelaDeInconsistenciasGestorComponent,
    ListaDeInconsistenciaComponent,
    ListagemDeInconsistenciaComponent,
    MeusBensModalComponent,
    TelaInconsistenciasGestorModalComponent,
    TelaDeInconsistenciaUserModalComponent,
    ListagemDeInconsistenciaModalComponent,
    TelaDeRecebimentoModalComponent,
    HistoricoBensModalComponent,
    GrupoCautelaComponent,
    CautelaGruposComponent,
    RecebimentoGrupoComponent,
    GrupoRecebimentoComponent,
    AlterarCautelaGrupoComponent,
    GrupoAlterarCautelaComponent,

  ],
  imports: [
    BrowserModule,
    NgbModalModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forRoot(maskConfig),
    AutocompleteLibModule,
    NgbCollapseModule,
    CommonModule,
    Ng2SearchPipeModule,
    TelaDeLiberacaoModule,
    TelaDeLiberacaoRoutingModule,
    AppRoutingModule,
    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AuthenticationService,
    CadastroBemService,
    LoginService,
    TipoDeBemService,
    SideMenuService,
    PageService,
    LocalizacaoService,
    UploadService,
    MovimentacaoService,
    DatePipe,
    PermissaoService,
    PageService,
  ],
  entryComponents:[CadastroBensModalComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
